<template>
  <InterfaceCard
      title="Операции баланса"
  >
    <template v-slot:image>
      <v-skeleton-loader
          v-if="!balanceData"
          type="card-avatar"
      ></v-skeleton-loader>
      <v-img v-else :src="balanceData.customer.photo"></v-img>
    </template>
    <template v-slot:subtitle>
      <div v-if="balanceInfo">
        <a class="accent--text"
           :href="balanceInfo.owner.url"
           target="_blank"
        >
          <span v-if="balanceInfo.owner.balanceType === types.personal">организатор: </span>
          <span v-else-if="balanceInfo.owner.balanceType === types.group">группа: </span>
          {{balanceInfo.owner.title}}
        </a>
      </div>
      <v-skeleton-loader
          v-else
          class="mb-0"
          type="text"
          width="250"
      >
      </v-skeleton-loader>
    </template>

    <div v-if="loading">
      <div
          v-for="i in 3"
          :key="i"
      >
        <v-skeleton-loader type="list-item-avatar-three-line">
        </v-skeleton-loader>
        <v-divider
            v-if="i !== 3"
            :inset="i !== 1"
        ></v-divider>
      </div>
    </div>

    <div v-else-if="error">
      <Info :error="error"></Info>
    </div>

    <v-list
        v-else
        :dense="$vuetify.breakpoint.mobile"
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-icon
              :class="`${sign}--text`"
          >
            mdi-wallet
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title :class="`${sign}--text`">
            <b>{{balanceInfo.balance | number}} {{ccy}}</b>
          </v-list-item-title>
          <v-list-item-subtitle>итого на балансе</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>

      <BalanceOperationListItem
          v-for="(item, index) in balanceData.items"
          :key="item.id"
          :buyout="balanceData.buyouts && balanceData.buyouts[item.buyoutId]"
          :ccy="ccy"
          :creator="balanceData.profiles[item.creatorId]"
          :divider="index < balanceData.items.length - 1"
          :item="item"
      ></BalanceOperationListItem>
    </v-list>

  </InterfaceCard>
</template>

<script>
import BalanceOperationListItem from '@/components/BalanceOperationListItem'
import Info from '@/components/Info'
import InterfaceCard from '@/components/InterfaceCard'
import {appStates, ccy, types} from '@/constants'

export default {
  name: 'BalanceOperationList',
  components: {BalanceOperationListItem, Info, InterfaceCard},
  created () {
    if (this.balanceInfo) {
      this.$client.get(this.$API.BALANCES.ITEMS, {params: {ownerId: this.balanceInfo.owner.id}})
      .then(data => this.balanceData = data)
      .catch(err => this.error = err)
      .finally(() => this.loading = false)
    } else {
      this.$router.replace({name: appStates.userProfile.name})
    }
  },
  computed: {
    sign () {
      if (this.balanceInfo && this.balanceInfo.balance > 0) {
        return 'green'
      } else if (this.balanceInfo && this.balanceInfo.balance < 0) {
        return 'red'
      }
      return 'gray'
    }
  },
  data () {
    return {
      ccy: ccy.RUB.sign,
      error: null,
      balanceData: null,
      loading: true,
      types: types.balance
    }
  },
  props: {
    balanceInfo: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>